import { Card,Grid,Skeleton,Stack } from "@mui/material";
import { motion } from "framer-motion";

const CardFormularioSkeleton = () => {
  return (
    <Card sx={{ p: 2, width: '100%', height: '100%' }}>
      <Stack
        direction="row"
        spacing={4}
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
          <Skeleton variant="text" width="70%" height={32} />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="65%" />
          <Skeleton variant="text" width="55%" />
        </Stack>
        <Stack direction="column" spacing={1} alignItems="center">
          <Stack direction="column" spacing={1}>
            <Skeleton variant="rectangular" width={120} height={40} />
            <Skeleton variant="rectangular" width={120} height={40} />
            <Skeleton variant="rectangular" width={120} height={40} />
          </Stack>
          <Skeleton variant="circular" width={40} height={40} />
        </Stack>
      </Stack>
    </Card>
  );
};

export default function CardFormularioSkeletonGrid({length}: {length: number}) {
  const skeletons = Array.from({ length: length });

  return (
    <Grid container spacing={2}>
      {skeletons.map((_, index) => (
        <Grid size={{ sm: 12, md: 6 }} key={index}>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: index * 0.15,
              duration: 0.3,
            }}
          >
            <CardFormularioSkeleton />
          </motion.div>
        </Grid>
      ))}
    </Grid>
  );
}
